(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ew-crystal-shop"] && !Shopify.designMode) return;
  try {
    
  function initializeCrystalCarousels(root=document){
    root.querySelectorAll('[data-crystal-carousel]').forEach(section=>{
      if(section.dataset.carouselReady)return;
      section.dataset.carouselReady='true';
      const track=section.querySelector('.ew-crystal-shop__track');
      if(!track)return;
      const buttons=section.querySelectorAll('[data-crystal-direction]');
      const update=()=>buttons.forEach(button=>{button.disabled=Number(button.dataset.crystalDirection)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;});
      buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.crystalDirection)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
      track.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  initializeCrystalCarousels();
  document.addEventListener('shopify:section:load',()=>initializeCrystalCarousels());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
